<!-- HTML -->
<template>
  <div class="container" style="width: 100%;">
    <div class="flex full-page-header">
      <div class="flex items-center">
        <pl-button @click.native="backToPrevious" class="header-title">
          <i class="fa fa-arrow-left mr2" />
          <span> Back </span>
        </pl-button>
      </div>
      <div class="flex items-center justify-center w-100">
        <img class="avatar" :src="user.avatar_url" alt="avatar" />
        <span class="header-title b ml2">
          {{ user.name }}
        </span>
      </div>
    </div>
    <fixed-side-bar
      :sizeOfFixedSideInPixels="display_acitivty_list ? side_bar_width : 0"
      class="student-activity-summary-page absolute"
      navBackgroundColor="#fcfcfc"
      bodyBackgroundColor="white"
    >
      <!-- Activity Selection Bar -->
      <fixed-nav-bar
        v-show="display_acitivty_list"
        :heightOfNavInPixels="75"
        slot="side-nav-slot"
        class="center-xs pl-white-smoke absolute w-100"
        :style="`max-width:${side_bar_width}px`"
      >
        <div
          slot="nav-slot"
          style="width: 100%; height: 100%; margin-top: 10px;"
        >
          <div>
            <pl-button
              class="pl-white b ttu"
              @click.native="exportStudentReport"
            >
              <img src="/static/export.svg" />
              Export Report
            </pl-button>
          </div>
        </div>

        <activities-side-bar
          slot="body-slot"
          :activities="activities"
          class="activities-list left-side"
          @summarySelected="type_selected = 'summary'"
          @activitySelected="displayActivity"
          :summarySelected="type_selected === 'summary'"
        />
      </fixed-nav-bar>

      <!-- Body of measure -->
      <fixed-nav-bar
        :heightOfNavInPixels="80"
        slot="side-body-slot"
        class="student-activity-body"
      >
        <div
          slot="nav-slot"
          style="height: 100%; border-bottom: 1px solid #ececec;"
          class="row no-margin middle-xs"
        >
          <div
            class="flex ma3"
            @click="display_acitivty_list = !display_acitivty_list"
            :class="{ 'toggle-side-bar': hovered }"
            @mouseenter="hovered = true"
            @mouseleave="hovered = false"
          >
            <div class="customize-tooltip">
              <img
                v-if="!hovered && display_acitivty_list"
                src="/static/logos/collapse_black.svg"
                alt="hide"
              />
              <img
                v-else-if="hovered && display_acitivty_list"
                src="/static/logos/collapse_blue.svg"
                alt="hide"
              />
              <img
                v-else-if="!hovered && !display_acitivty_list"
                src="/static/logos/expand_black.svg"
                alt="hide"
              />
              <img v-else src="/static/logos/expand_blue.svg" alt="hide" />
              <div v-if="hovered">
                {{ display_acitivty_list ? 'collapse' : 'expand' }}
              </div>
            </div>
          </div>
          <div class="middle-xs truncate-text" style="width: 85%;">
            <div v-if="type_selected !== 'summary'">
              <span
                style="font-weight: bold; white-space: nowrap; font-size: 24px;"
              >
                {{ selected_activity.title }}
                <br />
              </span>
              <div style="height: 20px;">
                <span style="font-size: 14px;">{{ activity_date }} </span>
                <span
                  class="pl-primary i ph2"
                  style="cursor: pointer;"
                  @click="jumpToRoundTable"
                >
                  Jump to RoundTable
                </span>
              </div>
            </div>
            <div v-else>
              <span
                style="font-weight: bold; white-space: nowrap; font-size: 24px;"
              >
                Trending Reports
              </span>
            </div>
          </div>
        </div>
        <template slot="body-slot">
          <ld-measure
            style="margin-top: 20px; margin-bottom: 100px;"
            class="individual-activity-summary center-xs"
            v-if="type_selected === 'Live' && !is_loading"
          />

          <!-- Online RT Individual summary / Submission card -->
          <!-- Online RT Individual summary / Submission card -->
          <template v-else-if="type_selected === 'Online'">
            <div
              class="flex justify-center items-center h-100"
              v-if="is_loading"
            >
              <div key="loading" class="flex center-xs middle-xs h-inherit">
                <p>Loading RoundTable</p>
                <div class="flex justify-center">
                  <pl-spinner />
                </div>
              </div>
            </div>
            <div v-else style="margin-bottom: 100px;">
              <by-pass-card
                v-show="show_by_pass_card"
                style="margin: 20px auto; width: 700px;"
                :submission="submission"
                :showAssessmentByDefault="true"
              />
              <submission-card
                v-show="!show_by_pass_card && submission"
                style="margin: 20px auto; width: 700px;"
                :submission="submission"
                :studentActivitySummary="true"
              />
              <div
                class="pl-headline center-xs mt3"
                v-show="!show_by_pass_card && !submission"
              >
                The student did not submit anything for this RoundTable
              </div>
            </div>
          </template>

          <!-- Show loading spinner if necessary -->
          <div
            class="flex justify-center items-center h-100"
            v-else-if="is_loading"
          >
            <pl-spinner class="x2" />
          </div>

          <div v-else class="student-activity-body-card center-xs">
            <trending-charts
              class="trending-charts"
              v-if="type_selected === 'summary'"
            />
          </div>

          <!-- Comment and Reply overlays go here -->
          <individual-comment-overlay
            @close="closeOverlay"
            v-if="show_overlay === 'comment' && submission_in_overlay"
            :submission="submission_in_overlay"
            key="individual-comment-overlay"
          />
          <individual-reply-overlay
            @close="closeOverlay"
            v-if="show_overlay === 'reply' && submission_in_overlay"
            :submission="submission_in_overlay"
            key="individual-reply-overlay"
          />
        </template>
      </fixed-nav-bar>
    </fixed-side-bar>
  </div>
</template>

<!-- JAVASCRIPT -->
<script lang="babel">
  import store from 'store';
  import { mapGetters } from 'vuex';
  import find from 'lodash/find';
  import moment from 'moment';
  // COMPONENTS
  import StudentSummaryReportLayout from 'layouts/fixedSideBarInsideFixedTop/fixedSideBarInsideFixedTop';
  import ldMeasure from 'features/measureLiveDiscussion/individualStudentLDSummary';
  import activitiesSideBar from './components/activitiesSideBar/activitiesSideBar.vue';
  import FixedSideBar from 'layouts/fixedSideBar/fixedSideBar.vue';
  import FixedNavBar from 'layouts/fixedNavBar/fixedNavBar.vue';
  import SubmissionCard from 'features/onlineRoundtables/components/submissionCard/submissionCard';
  import trendingCharts from './components/trendingCharts';
  import ByPassCard from '../onlineRoundtables/components/byPassCard.vue';
  // Overlays
  import IndividualCommentOverlay from 'features/onlineRoundtables/components/individualCommentOverlay';
  import IndividualReplyOverlay from 'features/onlineRoundtables/components/individualReplyOverlay';

  import roundtableServices from 'features/onlineRoundtables/onlineRoundtables.services.js';
  import exportStudentReportData from 'services/courses/exportStudentReportData';
  import downloadFile from 'utils/downloadFile';

  export default {
    data() {
      return {
        activities: [],
        selected_activity: {},
        type_selected: null, // Can be null, 'Live', or 'Online', or 'summary'
        activity_details: {},
        is_loading: false,
        show_overlay: '',
        hovered:false,
        side_bar_width:300,
        display_acitivty_list:true,
        submission_in_overlay: null,
        scrollToInOverlay: "",
      };
    },
    components: {
      ldMeasure,
      activitiesSideBar,
      FixedNavBar,
      FixedSideBar,
      trendingCharts,
      StudentSummaryReportLayout,
      SubmissionCard,
      ByPassCard,
      IndividualCommentOverlay,
      IndividualReplyOverlay,
    },
    /* watch: {
      '$route.query' () {
        const { submissionID, topLevelCommentID, replyCommentID } = this.$route.query;
        if (submissionID && topLevelCommentID && !replyCommentID) {
          this.getSubmissionForOverlay()
            .then(() => {
              this.show_overlay = 'comment';
            });
        } else if(submissionID && topLevelCommentID && replyCommentID) {
          this.getSubmissionForOverlay()
            .then(() => {
              this.show_overlay = 'reply';
            });
        }
      },
    } */
    computed: {
      ...mapGetters([
        'getStudentSummary',
        'getCourseDetail',
        'getCurrentRT',
        'hasTeacherPermissionsInCourse',
        'getCourseLayoutFullScreenStatus',
      ]),
      show_by_pass_card() {
        return this.submission &&
          this.submission.by_pass_date &&
          !this.submission.start_date;
      },
      activity_date() {
        const { published_date } = this.selected_activity;
        if (published_date) {
          return moment(published_date, moment.ISO_8601).format('MMMM Do[,] YYYY');
        }
        return null;
      },
      submission() {
        return this.getCurrentRT.submissions[0];
      },
      // Find the user object of the user we're viewing to display in header
      user() {
        const user_in_state = find(this.getCourseDetail.users,
          user => user.id === this.$route.params.studentID);
        return user_in_state
          ? { name: user_in_state.name, avatar_url: user_in_state.avatar_url }
          : { name: '', avatar_url: ''};
      },
    },
    methods: {
      jumpToRoundTable() {
        if (this.type_selected === 'Online'){
          this.jumpToOnline();
        }
        if (this.type_selected === 'Live'){
          this.jumpToLive();
        }
      },
      jumpToOnline(){
        const { courseID } = this.$route.params;
        const roundtableID = this.selected_activity.users[0].submission.roundtable_id;
        const submissionID = this.selected_activity.users[0].submission.id;
        const tab = 'comments';
        this.$router.replace({
          name: 'roundtable.feed',
          params: {
            courseID,
            roundtableID,
          },
          query: {
            submissionID,
            tab,
          }
        });
      },
      jumpToLive() {
        const { courseID } = this.$route.params;
        const liveDiscussionID = this.$route.query.activityID;
        this.$router.replace({
          name: 'live-discussion.index',
          params: {
            liveDiscussionID,
            courseID
          },
        });
      },
      exportStudentReport(){
        const { courseID,studentID } = this.$route.params;
        exportStudentReportData(courseID,studentID).then(res => {
          const file = res.data;
          const filename = `${this.getCourseDetail.title}-${this.user.name}.xlsx`;
          downloadFile(file,filename,'xlsx');
        });
      },
      closeOverlay() {
        this.show_overlay = '';
        this.scrollToInOverlay = null;
        this.$router.replace({
          query: Object.assign({}, this.$route.query, {
            submissionID: null,
            replyCommentID: null,
            topLevelCommentID: null,
          }),
        });
      },
      getSubmission(submissionID) {
        roundtableServices.viewSubmission(submissionID)
          .then((res) => {
            this.submission = res.data;
        });
      },
      // This is the activity that comes up through the side bar when selected
      displayActivity(activity) {
        this.fetchActivity(activity);
        this.$router.replace({
          query: {
            ...this.$route.query,
            activityID: activity.id,
          },
        });
      },
      fetchActivity(activity){
        this.is_loading = true;
        if (activity.type === 'live_discussion') {
          this.displayLDSummary(activity.users[0].participation.id);
          this.type_selected = 'Live';
          this.$store.dispatch('fetchLiveDiscussion',activity.id)
          .then(this.finishLoading)
          .catch(this.finishLoading);
        } else if (activity.type === 'roundtable') {
          //submission is loaded when opening the submission
          this.type_selected = 'Online';
          this.activity_details = activity.users[0].submission;
          const query = {submission_id:activity.users[0].submission.id};
          const request = { roundtableID: activity.id, query };
          this.$store.dispatch('fetchRoundtableSettings',request)
          .then(() => {
            this.finishLoading();
            })
          .catch(this.finishLoading);
          }
        this.selected_activity = activity;
      },
      finishLoading() {
        this.is_loading = false;
        return null;
      },
      displayRTSummary(submissionID) {
        return store.dispatch('getSubmissionSummary', submissionID);
      },
      displayLDSummary(participationID) {
        return store.dispatch('fetchParticipationSummary', participationID);
      },
      backToPrevious() {
        this.$router.go(-1);
      },
      fetchStudentActivities() {
        const { courseID, studentID } = this.$route.params;
        store.dispatch('analytics', 'teacher student reports - view student reports page');
        return store.dispatch('setCourseStudentActivities', { courseID, studentID }).then((activities) => {
            this.activities = activities;
            this.findSummaryDefaultSummaryToDisplay();
          });
      },
      findSummaryDefaultSummaryToDisplay() {
        const { query } = this.$route;
        if (this.activities.length) {
          const activity = find(this.activities, { id: query.activityID });
          activity ? this.displayActivity(activity) : this.type_selected = 'summary';
        }
      },
    },
    mounted() {
      this.side_bar_width = window.innerWidth < 800 ? 200 : this.side_bar_width;
      window.addEventListener('resize', () => {
        this.side_bar_width = window.innerWidth < 800 ? 200 : 300;
      });
      // fetch course activities
      if (!this.$route.query.activityID) {
        this.type_selected = 'summary';
      }
      if (!this.getCourseDetail.id){
          this.$store.dispatch('fetchCourseDetails', this.$route.params.courseID);
      }
      this.fetchStudentActivities();
    },
    beforeDestroy(){
      this.$store.dispatch('resetRoundtableGrades');
    }
  };
</script>

<style lang="stylus" scoped media="screen">
  @import '~app/global-stylus.styl'
  .pl-white-smoke
    background-color: pl-white-smoke
  .full-page-header
    height:50px;
    width:100%
    text-align:center
    background: pl-primary
  .pl-primary
    color:pl-primary
  .header-title
    color: white;
    font-size:20px;
  .avatar
    height: 40px
    width: 40px
    margin: 10px
    border-radius: 50%
    border: 1px solid alpha(pl-slate, 0.7)
  ::-webkit-scrollbar {
    display: block !important;
    width: 8px !important;
    -webkit-appearance: none;
  }
  .student-activity-summary-page
    .student-activity-body-card
      width: 100%;
      padding: 20px;
      .summary-container
        height: inherit
        width: 100%
        padding: 40px 20px
    .student-activity-summary-online-content
      padding: 40px 20px;

    .trending-charts
      padding: 1em;
      max-width: 1000px;
      margin: auto;

  .customize-tooltip
    img
      cursor: pointer
    div
      box-shadow: 0 0 4px 2px rgba(0,0,0,.2)
      position: absolute
      width: 70px
      color: #43484c
      background-color: #fff
      border-radius: 5px
      padding: 5px
      margin-left: -14px
      margin-top: 7px
      font-size: 12px
      font-weight: 600
      z-index: 2
      text-align: center
  .customize-tooltip div:before{
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }
</style>



// WEBPACK FOOTER //
// studentActivitySummary.vue?5cee77e0